<template>
  <div class="dialogCommunication">
    <dialogTitle name="新增记录" />
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="" prop="desc">
        <el-input
          type="textarea"
          v-model="ruleForm.desc"
          placeholder="请输入沟通记录"
        ></el-input>
      </el-form-item>
    </el-form>
    <dialogTitle name="历史记录" />
    <template v-if="logs.length">
      <div class="CommunicationMain">
        <div
          class="CommunicationMainItem"
          v-for="(item, index) in logs"
          :key="index"
        >
          <h3>{{ item.time }}</h3>
          <p>
            {{ item.note }}
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="CommunicationMain"><h3>暂无</h3></div>
    </template>
    <div class="CommunicationFooter">
      <el-button type="primary" @click="submitForm('ruleForm')"
        >提交记录</el-button
      >
    </div>
  </div>
</template>

<script>
import dialogTitle from "./dialogtitle";
import { writeCommunicationLog, queryExpertApplyCommunicationLogs } from "@/api/alicp";
export default {
  props: ["channelNeedNo"],
  data() {
    return {
      ruleForm: {
        desc: "",
      },
      rules: {
        desc: [
          {
            required: true,
            message: "请输入沟通记录",
            trigger: "blur",
          },
        ],
      },
      logs: [],
    };
  },
  components: {
    dialogTitle,
  },
  mounted() {
    this.queryExpertApplyCommunicationLogs();
  },
  methods: {
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/年|月/g, "-")
        .replace(/日/g, " ");
    },
    //获取沟通记录
    queryExpertApplyCommunicationLogs() {
      let obj = {
        intentionBizId: this.channelNeedNo,
        BeginTime: "",
        EndTime: "",
        PageNum: "1",
        PageSize: "100",
      };
      queryExpertApplyCommunicationLogs(obj).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.logs = [];
          res.data.data.Data.map((item) => {
            console.log('item++++++++',item)
            this.logs.push({
              ...item,
              // time: this.getLocalTime(item.createTime),
              // time: this.utc2beijing(item.createTime),
              time:this.getLocalTime(this.utc2beijing(item.createTime)),
              note:item.content
            });
          });
        }
      });
    },

    //utc转北京时间(return beijing_datetime)
    //utc转时间戳(return timestamp)
    utc2beijing(utc_datetime) {
    // 转为正常的时间格式 年-月-日 时:分:秒
    var T_pos = utc_datetime.indexOf('T');
    var Z_pos = utc_datetime.indexOf('Z');
    var year_month_day = utc_datetime.substr(0,T_pos);
    var hour_minute_second = utc_datetime.substr(T_pos+1,Z_pos-T_pos-1);
    var new_datetime = year_month_day+" "+hour_minute_second; // 2017-03-31 08:02:06

    // 处理成为时间戳
    timestamp = new Date(Date.parse(new_datetime));
    timestamp = timestamp.getTime();
    timestamp = timestamp/1000;

    // 增加8个小时，北京时间比utc时间多八个时区
    var timestamp = timestamp+8*60*60;

    // // 时间戳转为时间
    // var beijing_datetime = new Date(parseInt(timestamp) * 1000).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ");
    // return beijing_datetime; // 2017-03-31 16:02:06
    return timestamp
  }, 

// console.log(utc2beijing(utc_datetime));

    //提交沟通记录
    submitForm(formName) {
      let obj = {
        intentionBizId: this.channelNeedNo,
        note: this.ruleForm.desc,
      };
      this.$refs[formName].validate((valid) => {
        console.log(obj, "valid");
        if (valid) {
          this.$emit("tolkParent", { loading: true, dialog: true });
          writeCommunicationLog(obj).then((res) => {
            console.log(res, "resresres");
            if (res.status == 0) {
              this.$message({
                message: "提交记录成功！",
                type: "success",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: false,
              });
              this.ruleForm.desc = "";
              this.queryExpertApplyCommunicationLogs();
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
              this.$emit("tolkParent", {
                loading: false,
                dialog: true,
              });
            }
          });
        } else {
          this.$message({
            message: "请输入沟通记录",
            type: "warning",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.dialogCommunication {
  width: 100%;
  max-height: 700px;
  overflow: auto;
  .el-form {
    width: 100%;
    .el-form-item {
      .el-form-item__content {
        margin-left: 50px !important;
        .el-textarea__inner {
          height: 200px;
          width: 550px;
        }
      }
    }
  }
  .CommunicationMain {
    width: 100%;
    padding: 0 50px;
    padding-bottom: 10px;
    .CommunicationMainItem {
      margin-bottom: 20px;
      h3 {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(38, 38, 38, 0.6);
        line-height: 22px;
        letter-spacing: 1px;
        margin-bottom: 10px;
      }
      p {
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(38, 38, 38, 1);
        line-height: 22px;
        letter-spacing: 1px;
      }
    }
  }
  .CommunicationFooter {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      background: #ff8a01;
      border: none;
    }
  }
}
</style>
